import { render, staticRenderFns } from "./TextEditorsTiny.vue?vue&type=template&id=67416f9b&scoped=true"
import script from "./TextEditorsTiny.vue?vue&type=script&lang=js"
export * from "./TextEditorsTiny.vue?vue&type=script&lang=js"
import style0 from "./TextEditorsTiny.vue?vue&type=style&index=0&id=67416f9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67416f9b",
  null
  
)

export default component.exports